import http from "../../../core/utils/apis/api";

const createQuiz = async (data) => {
    try {
        const response = await http({
            method: "Post",
            url: `/quiz`,
            data: data,
            headers: {
                'Content-Type': 'application/json',
            },
        });
        
        return response;
    } catch (e) {
        throw e;
    }
};

const createFormAnswersWithOptions = async (data) => {
    try {
        const response = await http({
            method: "Post",
            url: `/form-answers-options`,
            data: data,
            headers: {
                'Content-Type': 'application/json',
            },
        });
        
        return response;
    } catch (e) {
        throw e;
    }
};


const updateQuiz = async (data) => {
    try {
        const response = await http({
            method: "Patch",
            url: `/quiz`,
            data: data,
            headers: {
                'Content-Type': 'application/json',
            },
        });
        
        return response;
    } catch (e) {
        throw e;
    }
};


const getForms = async (options) => {
    try {
        const response = await http({
            method: "GET",
            url: `/forms`,
            params: options,
        });
        return response;
    } catch (e) {
        throw e;
    }
};

const getTrainingsByCourse= async (id,options) => {
    try {
        const response = await http({
            method: "GET",
            url: `/trainings/by-course/${id}`,
            params: options,
        });
        return response;

    } catch (e) {
        throw e;
    }
};

const updateForm = async (form) => {
    const { id, ...data } = form;
    try {
        const response = await http({
            method: 'PATCH',
            url: `/forms/${form.id}`,
            data: data,
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response;
    } catch (e) {
        throw e;
    }
}

const getOneForm = async (id) => {
    try {
        const response = await http({
            method: 'GET',
            url: `/forms/${id}`,

        });

        return response;
    } catch (e) {
        throw e;
    }
}

const getFormByCourseId = async (id) => {
    try {
        const response = await http({
            method: 'GET',
            url: `/forms/by-course/${id}`,

        });

        return response;
    } catch (e) {
        throw e;
    }
}



const quizManagementService = {
    getForms,
    updateForm,
    createQuiz,
    getOneForm,
    updateQuiz,
    getFormByCourseId,
    getTrainingsByCourse,
    createFormAnswersWithOptions
};

export default quizManagementService;
